<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;    align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top: 185px;">
            <div class="home1 ac">
              <img :src="isEN=='bur'?'../../static/images/login-bg4.png':'../../static/images/login-bg4.png'">
            </div>
          </div>
          <div class="">
            <div class="lg-bg2">
              <div class="ac mt30">
                <div class="span fs26 ac fw7" style="font-weight: 400;margin-bottom: 10px;">{{$t('join_us')}}</div>
                <div class="span fs26 ac fw7" style="font-weight: 400">{{$t('landFont2')}}</div>
                <div class="scrollLight font-family">
                  <div class="scroll-wrapper">
                    <div
                      class="scroll-item"
                      v-for="(item, index) in scrollLightData"
                      :key="index"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
                <div class="drown-list disflex drown-bg" style="">
                  <div class="">
                    <div class="disflex" v-if="showDaily">
                      <div class="drown-li"  @click="getType('daily')">
                        <div class="day disflex " >
                          <span>{{$t('Daily')}} ></span>
                        </div>
                      </div>
                    </div>
                    <div class="disflex"  v-if="showWeekly">
                      <div class="drown-li"  @click="getType('weekly')">
                        <div class="week disflex " >
                          <span>{{$t('Weekly')}} ></span>
                        </div>
                      </div>
                    </div>
                    <div class="disflex" v-if="showMonthly">
                      <div class="drown-li" @click="getType('monthly')">
                        <div class="disflex month" >
                          <span>{{$t('Monthly')}} ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-content ac" style="justify-content: space-evenly;">
              <div class="icon icon2" @click="getHref('faq')">
                <img src="../../static/images/menu-icon5.png" />
                <span>{{$t('FAQs')}}</span>
              </div>
              <div class="icon icon3" @click="getHref('termsAndCondition')">
                <img src="../../static/images/menu-icon6.png" />
                <span>{{$t('TC')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      type:'daily',
      isEN:'bur',
      mobile:'',
      showDaily: true,  // 控制 daily 的显示
      showWeekly: true,  // 控制 weekly 的显示
      showMonthly: true,  // 控制 monthly 的显示
      //走马灯
      scrollLightData:{}
    }
  },
  created(){
    this.report_page();
    this.scrollLight();
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile){
      let that = this
      that.mobile = this.$route.query.mobile;
    }
    var type  = this.$route.query.type
    if (type === 'day'){
      this.showDaily = true
      this.showWeekly = false
      this.showMonthly = false
    }else if(type === 'week'){
      this.showDaily = false
      this.showWeekly = true
      this.showMonthly = false
    }else if(type === 'month'){
      this.showDaily = false
      this.showWeekly = false
      this.showMonthly = true
    }else{
      this.showDaily = true
      this.showWeekly = true
      this.showMonthly = true
    }
  },
  methods: {
    getHref(type){
      this.$router.push({path:type,query:{type:type}});
    },
    back(){
      this.$router.go(-1);
    },
    getType(type){
      this.type = type
      this.goLogin()
    },
    goLogin(){
      let that = this
      let queryParams = this.$route.query;
      if(!that.mobile){
        //没有号码直接跳登录页面
        that.$router.push({path:'/login',query: {...queryParams,type:that.type}})
      }else{
        //有号码直接订阅登录
        that.$parent.loadModal(true);
        let mobile = this.mobile
        let type  = this.type
        delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
        delete queryParams.type; // 删除 type，避免 URL 里重复
        let queryString = Object.keys(queryParams).length
          ? '&' + Object.entries(queryParams)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&')
          : '';
        let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
        that.$api.get(url, {},r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if (r.code == 1){
              that.$parent.returnCode(r,function(){
                localStorage.setItem('token',r.data.userinfo.token)
                localStorage.setItem('mobile',r.data.userinfo.mobile)
                that.$router.push('/');
              });
            }else{
              that.$utils.alertText(r.msg,80, 3000);
            }
          });
        })
      }
    },
    report_page(){
      let that = this
      let track_token = this.$route.query.track_token;
      let mobile = this.$route.query.mobile;
      let data = {'type': 'land','mobile':mobile,'track_token':track_token}
      that.$api.post('/api/report/process', data, r => {
        that.$parent.returnCode(r, function () {

        })
      })
    },
    scrollLight(){
      let that = this
      let data = {
      }
      that.$api.post('/api/index/scroll_light',data,r =>{
        that.$parent.returnCode(r,function(){
          that.scrollLightData = r.data
        })
      })
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
.cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
.input-item{background:url(../../static/images/input-bg.png) no-repeat center center;background-size: contain;height: 102px;width: 474px;display: flex;align-items: center;}
.input-div div span{color:#0036af;}
.input-div .input{color:#0036af;}
.drown-list{width: auto;margin-top: -40px;justify-content: center;padding:45px 20px 0}
.drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
.drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;    margin-top: -12px;}
.week{background: url(../../static/images/week.png) no-repeat;background-size: contain;min-height: 120px;width: 340px;margin: 0 auto;}
.day{background: url(../../static/images/daily.png) no-repeat;background-size: contain;min-height: 170px;width: 400px;margin: 0 auto;}
.month{background: url(../../static/images/month.png) no-repeat;background-size: contain;min-height: 170px;width: 400px;margin: 0 auto;}
.lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}


.scrollLight {
  height: 120px;
  overflow: hidden;
  position: relative;
  //background: rgba(255,255,255,0.15);
  color: #fff;
  font-size: 28px;
  line-height: 60px;
  text-align: center;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  animation: scrollUp 60s linear infinite;
}

.scroll-item {
  height: 60px;
  white-space: nowrap;
  padding-left: 20px;
  color: red;
}

/* 向上滚动动画 */
@keyframes scrollUp {
  0% { transform: translateY(0); }
  100% { transform: translateY(-100%); }
}

</style>



// WEBPACK FOOTER //
// src/page/land.vue